import { PostType } from 'src/hook/usePosts';
import {
  ComponentName,
  ComponentSource,
  ContentType,
  TryResult
} from 'src/utils/datahubDefaultEvent';

export type UseTrackEventsProps = {
  loggedUserUcode?: string;
};

export type SendPostDetailEventParams = {
  communityId: number | string;
  id: number | string;
  type?: PostType;
};

export type SendReactPostEventParams = {
  result: TryResult;
  statusCode?: number;
  failureDescription?: string;
  userUcode?: string;
};

export type SendReadActivitiesEventParams = {
  contentType: ContentType;
  itemsCount: number;
  result: TryResult;
  componentSource: ComponentSource;
  statusCode?: number;
  failureDescription?: string;
};

export enum FailureDescription {
  ERROR_WHILE_FETCHING_DATA = 'ERROR_WHILE_FETCHING_DATA',
  NOT_FAILURE_RESULT_EVENT = 'NOT_FAILURE_RESULT_EVENT'
}

export type SendOpenProfileEventParams = {
  componentName?: ComponentName;
  userUcode?: string;
};

export type SendOpenMessageBoxEventParams = {
  userUcode?: string;
};

export type SendLoadHighlightsEventParams = {
  result: TryResult;
  userUcode?: string;
  statusCode?: number;
  failureDescription?: string;
  classCount?: number;
  commentCount?: number;
  postCount?: number;
};
